var React = require('react');

function Conventional (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28 2H4C3.46975 2.00061 2.9614 2.21152 2.58646 2.58646C2.21152 2.9614 2.00061 3.46975 2 4V28C2.00061 28.5302 2.21152 29.0386 2.58646 29.4135C2.9614 29.7885 3.46975 29.9994 4 30H28C28.5302 29.9994 29.0386 29.7885 29.4135 29.4135C29.7885 29.0386 29.9994 28.5302 30 28V4C29.9994 3.46975 29.7885 2.9614 29.4135 2.58646C29.0386 2.21152 28.5302 2.00061 28 2ZM28 14H23V4H28V14ZM16 4H21V14H16V4ZM14 4V20H4V4H14ZM4 22H14V28H4V22ZM16 28V16H28V28H16Z","fill":"currentColor"}));
}

Conventional.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Conventional;

Conventional.default = Conventional;
